import {
  ACTIVO_RESERVAS_RESTAURANTE,
  GETALL_RESERVAS_RESTAURANTE,
  LOADING_GETALL_RESERVAS_RESTAURANTE,
  PARAMS_RESERVAS_RESTAURANTE,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {
    areaId: null,
    codeId: null,
    date: null,
    dateTo: null,
    userId: null,
  },
};

export const reservasRestauranteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_RESERVAS_RESTAURANTE:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_RESERVAS_RESTAURANTE:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case LOADING_GETALL_RESERVAS_RESTAURANTE:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_RESERVAS_RESTAURANTE:
      return {
        ...state,
        params: action.payload,
      };
    default:
      return state;
  }
};
